import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSignatureProviders = createSelector(
  [(store: RootState) => store.signatureProviders.providers],
  // Devuelve el listado de proveedores de firma
  (data) => data
);